import { Cart } from '../types';

export const CART_STORAGE_KEY = 'webstore-cart';

export function createEmptyCart(id?: string): Cart {
  const now = new Date().toISOString();
  return {
    id: id || (typeof crypto !== 'undefined' && crypto.randomUUID ? crypto.randomUUID() : `${Date.now()}`),
    items: [],
    total: 0,
    createdAt: now,
    updatedAt: now,
  };
}

export function loadStoredCart(): Cart | null {
  try {
    const raw = localStorage.getItem(CART_STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as Cart;
    if (!parsed?.id || !Array.isArray(parsed.items)) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function persistCart(cart: Cart): void {
  try {
    localStorage.setItem(CART_STORAGE_KEY, JSON.stringify(cart));
  } catch {
    // Ignore quota / private-mode failures; in-memory state still works.
  }
}

export function clearStoredCart(): void {
  try {
    localStorage.removeItem(CART_STORAGE_KEY);
  } catch {
    // ignore
  }
}
